import React from "react";
import { Button, Form, Icon } from "semantic-ui-react";
import { Translate } from "react-localize-redux";


const ProductFieldInput = ({ name, title, context, integer, ...args }) => {
    const errors = args.errors || [name];
    return (
        <div>
            <Form.Input
                error={typeof context.state.errors !== "undefined" && Object.keys(context.state.errors)
                    .reduce((a, b) => {
                        if (errors.includes(b)) {
                            return true;
                        }
                        return a;
                    }, false)}
                action={context.state.product[name] !== context.props.product[name]}
                label={title}
                value={context.state.product[name]}
                onChange={(e) => {
                    context.setState({
                        product: {
                            ...context.state.product,
                            [name]: integer ? Number.parseInt(e.target.value, 10) : e.target.value
                        },
                        validated: false
                    }, () => {
                        context.dValidate();

                    });
                }}
                {...args}
            >
                <input/>
                {context.state.product[name] !== context.props.product[name] &&
                <Button type={"button"} icon labelPosition='left'
                        onClick={() => {
                            context.resetProductField(name);
                        }}
                >
                    <Icon name='repeat'/>
                    <Translate id="general.reset"/>
                </Button>
                }
            </Form.Input>
        </div>
    );
};

export default ProductFieldInput;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/MasterDataRequest/components/Steps/BasicInfos/components/ProductFieldInput/index.js